import "../../Styles/General & MultiUse/Navbar.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import ZGA from "../../Assets/ZGA.png";
import Auth from "../../Assets/Auth.png";
import { ZGAContext } from "../../ZGAContext";
import { RiCloseLargeLine } from "react-icons/ri";
import { RiMenuLine } from "react-icons/ri";

const Navbar = () => {
  const { user, setUser } = useContext(ZGAContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/")
  };

  return (
    <div className="navbar">
      <NavLink to="/">
        <img src={ZGA} alt="The Zulaykha Global Academy" />
      </NavLink>
      <ul className="navbarLarge">
        <NavLink to="/" className={({ isActive }) => (isActive ? "active-link" : "")}>
          HOME
        </NavLink>
        <NavLink to="/classes" className={({ isActive }) => (isActive ? "active-link" : "")}>
          OUR CLASSES
        </NavLink>
        <NavLink to="/sponsor" className={({ isActive }) => (isActive ? "active-link" : "")}>
          SPONSOR A STUDENT
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => (isActive ? "active-link" : "")}>
          CONTACT US
        </NavLink>
        {!user ? (
          <NavLink to="/auth/login">LOGIN</NavLink>
        ) : (
          <button onClick={handleLogout}>LOGOUT</button>
        )}
      </ul>
      <div className="navbarSmall">
        {isModalOpen ? (
          <span>
            <RiCloseLargeLine className="navbarSmallClose" onClick={toggleModal} />
          </span>
        ) : (
          <span>
            {user ? (
              <button>{user.firstName[0]}</button>
            ) : (
              <NavLink to="/auth/login">
                Login
                <img src={Auth} alt="Auth" />
              </NavLink>
            )}
            <RiMenuLine className="navbarSmallOpen" onClick={toggleModal}/>
          </span>
        )}
        {isModalOpen && (
          <ul className="navbarModal">
            <NavLink to="/" className={({ isActive }) => (isActive ? "active-link" : "")} onClick={toggleModal}>
              HOME
            </NavLink>
            <NavLink to="/classes" className={({ isActive }) => (isActive ? "active-link" : "")} onClick={toggleModal}>
              OUR CLASSES
            </NavLink>
            <NavLink to="/sponsor" className={({ isActive }) => (isActive ? "active-link" : "")} onClick={toggleModal}>
              SPONSOR A STUDENT
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "active-link" : "")} onClick={toggleModal}>
              CONTACT US
            </NavLink>
            {!user ? (
              <NavLink to="/auth/login">LOGIN</NavLink>
            ) : (
              <button onClick={handleLogout}>LOGOUT</button>
            )}
            {!user && <NavLink to="/auth/signup">SIGN UP</NavLink>}
          </ul>
        )}
      </div>
      {!isModalOpen && (user ? <button>{user.firstName[0]}</button> : <NavLink to="/auth/signup">SIGN UP</NavLink>)}
    </div>
  );
};

export default Navbar;
